import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { fetchApi } from "../helper/api";
import { useState } from "react";
import { IsAlert } from "../component/atoms/IsAlert";
import { TextField } from "@mui/material";
import ContentSensorMonitor from "../component/organisms/ContentSensorMonitor";
import $ from "jquery";
const SensorMonitor = () => {
  const [noIPC, setNoIPC] = useState("");
  const [listIPC, setListIPC] = useState([]);
  const routes = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    getIpc();
  }, []);
  const getIpc = async () => {
    const req = await fetchApi(`api/Ipc/${routes.id}`, "GET", true);
    const res = await req.json();
    const status = req.status;
    if (status) {
      // console.log(res.data);
      setListIPC(res.data);
    } else {
    }
  };
  const handleAddIPC = async () => {
    let self = this;
    const dataForm = {
      idBridge: routes.id,
      serialNumber: noIPC,
    };
    const req = await fetchApi("api/Ipc", "POST", true, dataForm);
    const status = req.status;
    const res = await req.json();
    if (status === 200) {
      IsAlert.fire({
        title: "Berhasil",
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          getIpc();
          $(".close").click();
        }
      });
    } else {
      IsAlert.fire({
        title: "Berhasil",
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    }
  };
  return (
    <div className="p-2">
      <div className=" justify-content-between align-items-center border-bottom pb-2 mb-2 d-none  ">
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          {listIPC.map((e, i) => {
            return (
              <li className="nav-item" key={e.serialNumber}>
                <a
                  className={`nav-link ${i === 0 && "active"}`}
                  id={`menu-pills-${i}`}
                  data-toggle="pill"
                  href={`#pills-${i}`}
                  role="tab"
                  aria-controls={`pills-${i}`}
                  aria-selected={i === 0 ? "true" : "false"}
                >
                  {e.serialNumber}
                </a>
              </li>
            );
          })}
        </ul>
        <div className="d-flex">
          <button
            className="btn btn-warning d-flex align-items-center"
            data-toggle="modal"
            data-target="#modalTambahIPC"
          >
            <i className="las la-plus mr-2"></i>
            Tambah IPC
          </button>
          <button
            className="btn btn-info d-flex align-items-center"
            onClick={() => {
              navigate(`/list-ipc/${routes.id}`);
            }}
          >
            <i className="las la-list mr-2"></i>
            List IPC
          </button>
        </div>
      </div>
      <div className="tab-content" id="pills-tabContent">
        {listIPC.map((e, i) => {
          return (
            <div
              key={e.serialNumber}
              className={`tab-pane fade ${i === 0 && "show active"}`}
              id={`pills-${i}`}
              role="tabpanel"
            >
              <ContentSensorMonitor
                dataIpc={e}
                idBridge={routes.id}
                role="Super User"
              />
            </div>
          );
        })}
      </div>
      <div
        className="modal fade"
        id="modalTambahIPC"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalDeleteLayoutLabel">
                Tambah IPC
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row mb-3">
                <div className="col-lg-12 mb-3">
                  <TextField
                    onChange={(e) => setNoIPC(e.target.value)}
                    value={noIPC}
                    className="w-100"
                    label="No. IPC"
                    variant="standard"
                    autoComplete="off"
                  />
                </div>
                <div className="col-lg-12 mb-3">
                  <TextField
                    value={routes.id}
                    className="w-100"
                    label="ID Jembatan"
                    variant="standard"
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                data-dismiss="modal"
              >
                Batal
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleAddIPC()}
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SensorMonitor;
